export default __webpack_public_path__ + "static/media/gordita-black.567c73d2.woff2";